
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 41.56 47.07"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_4","data-name":"Layer 4"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M40.63 40.18H.92a.93.93 0 00-.92.93v5.09a.87.87 0 00.87.87h3.88a.87.87 0 00.87-.87v-1.86h30.32v1.86a.87.87 0 00.87.87h3.88a.87.87 0 00.87-.87v-5.09a.93.93 0 00-.93-.93zM17.85 20.07H2.55a1.14 1.14 0 00-1.14 1.13v15.3a1.14 1.14 0 001.14 1.13h15.3A1.13 1.13 0 0019 36.5V21.2a1.13 1.13 0 00-1.15-1.13zM13.45 24a.5.5 0 01-.51.5H7.49A.51.51 0 017 24v-1.64a.52.52 0 01.51-.52h5.45a.51.51 0 01.51.52zM39.07 20.07h-15.3a1.12 1.12 0 00-1.13 1.13v15.3a1.12 1.12 0 001.13 1.13h15.3a1.13 1.13 0 001.13-1.13V21.2a1.13 1.13 0 00-1.13-1.13zM34.68 24a.51.51 0 01-.52.5h-5.44a.51.51 0 01-.52-.5v-1.64a.52.52 0 01.52-.52h5.44a.52.52 0 01.52.52zM28.44 0h-15.3A1.14 1.14 0 0012 1.14v15.31a1.14 1.14 0 001.13 1.13h15.3a1.15 1.15 0 001.15-1.13V1.14A1.15 1.15 0 0028.44 0zm-4.39 3.71a.52.52 0 01-.52.51h-5.44a.52.52 0 01-.52-.51V2.05a.51.51 0 01.52-.51h5.44a.51.51 0 01.52.51z"}})])])])
          )
        }
      }
    